<section *ngIf="versions.updateAvailable$ | async" class="release-banner" aria-label="Site update">
  <div class="release-copy" role="status" aria-live="polite">
    <strong>A new version of Coin Curiosity is available.</strong>
    <span>Reload when you’re ready to get the latest updates.</span>
    <span class="release-blocked" *ngIf="versions.reloadMessage$ | async as message">{{ message }}</span>
  </div>
  <div class="release-actions">
    <button type="button" class="release-primary" (click)="versions.requestReload()">Reload now</button>
    <button type="button" class="release-later" (click)="versions.later()">Later</button>
  </div>
</section>
<section *ngIf="announcements.announcement$ | async as announcement" class="announcement-banner" aria-label="Announcement">
  <span role="status">{{ announcement.message }}</span>
  <button type="button" (click)="announcements.dismiss()" aria-label="Dismiss announcement">Dismiss</button>
</section>
<router-outlet></router-outlet>
